import React, { FC } from 'react';
import styled from 'styled-components';
import { Theme, Svg } from 'styled';
import { Color } from 'styled/theme/colors';
import { svgHoverColor } from 'styled/utils';

type Props = {
  className?: string;
  primaryColor?: Color;
  secondaryColor?: Color;
};

const DislikeIcon: FC<Props> = ({
  className = '',
  primaryColor = 'white',
  secondaryColor = 'black',
}) => (
  <Svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    className={className}
    fill="transparent"
  >
    <desc>Like Icon.</desc>
    <circle
      r="20"
      transform="matrix(1 0 0 -1 20 20)"
      fill={Theme.colors[primaryColor]}
    />
    <path
      fill={Theme.colors[secondaryColor]}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5419 26.8311C22.7557 26.5487 22.8825 26.1967 22.8825 25.8151V25.0687V23.5687H24.3825H26.0613C26.3908 23.5724 26.7054 23.4312 26.9216 23.1825C27.1379 22.9339 27.234 22.6027 27.1845 22.2769L26.4095 17.2223C26.3255 16.6685 25.8463 16.2613 25.2863 16.2676H20.4512H18.9512V17.7676V22.4454L21.1977 27.5C21.6939 27.5 22.14 27.2855 22.4483 26.9442C22.4811 26.9079 22.5123 26.8702 22.5419 26.8311ZM25.2796 14.7676H18.9512C18.1227 14.7676 17.4512 15.4392 17.4512 16.2676V22.4454C17.4512 22.6553 17.4952 22.8628 17.5805 23.0546L19.8269 28.1092C20.0677 28.6509 20.6049 29 21.1977 29C22.9566 29 24.3825 27.5741 24.3825 25.8151V25.0687H26.0546C26.8204 25.0743 27.5507 24.745 28.0535 24.1668C28.5585 23.586 28.783 22.8128 28.6675 22.0518L28.6672 22.0496L27.8925 16.9974C27.8925 16.997 27.8924 16.9965 27.8923 16.996C27.6961 15.7068 26.5827 14.7579 25.2796 14.7676ZM17.7769 16.2675C17.7769 15.4391 17.1053 14.7675 16.2769 14.7675H14.592C13.1432 14.7675 11.9688 15.942 11.9688 17.3907V21.3221C11.9688 22.7708 13.1432 23.9453 14.592 23.9453H16.2769C17.1053 23.9453 17.7769 23.2737 17.7769 22.4453V16.2675ZM14.7769 16.2675H16.2769V17.7675V20.9453V22.4453H14.7769H14.592C13.9716 22.4453 13.4688 21.9424 13.4688 21.3221V17.3907C13.4688 16.7704 13.9716 16.2675 14.592 16.2675H14.7769Z"
    />
  </Svg>
);

export default styled(DislikeIcon)`
  ${svgHoverColor('blue-darker')}
`;
